<script lang="ts">
  let { value }: { value: string } = $props();
  let message = $state('');
  async function copy(e: MouseEvent) {
    e.stopPropagation();
    try { await navigator.clipboard.writeText(value); message = 'Copied'; }
    catch { message = 'Unable to copy; select the TCS ID manually.'; }
  }
</script>
<span class="inline-flex flex-wrap items-center gap-2 text-xs font-semibold">
  <span>TCS ID: {value}</span>
  <button type="button" class="min-h-9 px-2 underline" aria-label={`Copy TCS ID ${value}`} onclick={copy} onkeydown={e => e.stopPropagation()}>Copy</button>
  {#if message}<span role="status" class="font-normal">{message}</span>{/if}
</span>
